import { useMemo } from 'react';

import { useNotificationList } from '~/hooks/useNotificationList';

export interface UseLegacyNotificationsOutput {
  unreadNotificationsLength: number;
}

export const useLegacyNotificationsPaper = () => {
  const { notifications } = useNotificationList({ limit: 50 });
  const unreadNotificationsLength = useMemo(
    () => notifications?.filter((n) => !n.isRead).length,
    [notifications],
  );

  return {
    unreadNotificationsLength,
  };
};
